module.exports = {
  INIT: 'init',
  PLANNED: 'planned',
  VALIDATED: 'validated', // validated estimate / ongoing repair
  ENDED: 'ended',
};
